import { FC } from 'react';

// Import only the icons used by LocationFinder statically
import Location from '../../components/Icon/Icons/Location';
import ChevronDown from '../../components/Icon/Icons/ChevronDown';
import ChevronUp from '../../components/Icon/Icons/ChevronUp';
import Refresh from '../../components/Icon/Icons/Refresh';
import Search from '../../components/Icon/Icons/Search';
import Error from '../../components/Icon/Icons/Error';
import Check from '../../components/Icon/Icons/Check';
import List from '../../components/Icon/Icons/List';
import Map from '../../components/Icon/Icons/Map';

// Map icon names to components
const iconComponents = {
    Location,
    ChevronDown,
    ChevronUp,
    Refresh,
    Search,
    Error,
    Check,
    List,
    Map,
};

interface IconStaticProps {
    name: keyof typeof iconComponents;
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
    className?: string;
}

const IconStatic: FC<IconStaticProps> = ({ name, size = 'md', className }) => {
    // Use explicit width/height instead of Tailwind size classes for production
    const sizeMap = {
        xs: { width: '16px', height: '16px' },
        sm: { width: '18px', height: '18px' },
        md: { width: '24px', height: '24px' },
        lg: { width: '32px', height: '32px' },
        xl: { width: '40px', height: '40px' },
    };

    const sizeStyle = sizeMap[size] || sizeMap.md;

    const IconComponent = iconComponents[name];

    if (!IconComponent) {
        console.warn(`Icon component not found for: ${name}`);
        return null;
    }

    return (
        <i
            role="img"
            aria-label={name}
            style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: sizeStyle.width,
                height: sizeStyle.height,
                fill: 'currentColor',
            }}
        >
            <IconComponent
                style={{
                    ...sizeStyle,
                    display: 'block',
                    fill: 'currentColor',
                }}
                className={className}
            />
        </i>
    );
};

export default IconStatic;
